import { API_BASE_URL, apiGet, apiPatch, apiPost } from '@/api/http';

import type { UnreadNotificationsCountResponse } from '@/types/dashboard';
import type { NotificationSettings } from '@/types/user';
import type { CursorListingApiPayload } from '@/UI/filteredListing';

export type NotificationListItem = {
  id: string;
  text: string;
  created_at: string;
  is_read: boolean;
  [key: string]: unknown;
};

export const getUnreadNotificationsCount = () =>
  apiGet<UnreadNotificationsCountResponse>(
    `${API_BASE_URL}notifications/unread/count/`,
  );

export const getNotificationList = (next?: string) =>
  apiGet<CursorListingApiPayload<NotificationListItem>>(
    `${API_BASE_URL}notifications/${next ? '?' + next : ''}`,
  );

export const markAllNotificationsRead = () =>
  apiPost(`${API_BASE_URL}notifications/mark-all-as-read/`);

export const markNotificationAsRead = (id: string) =>
  apiPost(`${API_BASE_URL}notifications/${id}/mark-as-read/`);

export const getNotificationSettingList = () =>
  apiGet<NotificationSettings>(`${API_BASE_URL}notifications/settings/`);

export const updateNotificationSettingList = (data: NotificationSettings) =>
  apiPatch<NotificationSettings>(
    `${API_BASE_URL}notifications/settings/`,
    data,
  );
